import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import React from 'react'
import { useGlobalContext } from '../../Contexts/GlobalContext'
import { GroupNames } from '../../globalHeader/GlobalHeader'
import { useScreenSize } from '../../hooks/useScreenSize'
import { HintBonusIcon } from '../assets/HintBonusIcon'

interface IProps {
    amount?: number
}

const HintWithText: React.FC<IProps> = ({ amount = 0 }) => {
    const { isMobile } = useScreenSize()
    const { userType } = useGlobalContext()

    return (
        <Stack direction="row" alignItems="center" gap={1}>
            <Typography variant={isMobile ? 'body2' : 'body1'}>{`Earn ${amount}x`}</Typography>
            <HintBonusIcon />
            <Typography variant={isMobile ? 'body2' : 'body1'}>
                {`Hints ${userType === GroupNames.GUEST ? 'for signing up!' : 'for going premium!'}`}
            </Typography>
        </Stack>
    )
}

export default HintWithText
